// extracted by mini-css-extract-plugin
export default {"forType":"Center_forType__02Sww","typeTitle":"Center_typeTitle__Nj+ps","icon":"Center_icon__u2Gii","cancel":"Center_cancel__qTOLZ"};